export const useDelete = (
  getTrash,
  activeTab,
  handleCloseDeleteModal,
  handleDeleteIdeas,
  handleDeleteAttributes,
  handleDeleteComponents,
  handleDeleteProjects,
) => {
  const handleDelete = async () => {
    handleCloseDeleteModal();

    switch (activeTab) {
      case 0:
        await handleDeleteProjects();
        getTrash();
        break;
      case 1:
        await handleDeleteComponents();
        getTrash();
        break;
      case 2:
        await handleDeleteAttributes();
        getTrash();
        break;
      case 3:
        await handleDeleteIdeas();
        getTrash();
        break;
      default:
        console.error("Error: Invalid activeTab.");
    }
  };

  return {
    handleDelete,
  };
};
